import { render, staticRenderFns } from "./EditLiteralComponent.vue?vue&type=template&id=c4d82334&scoped=true&"
import script from "./EditLiteralComponent.vue?vue&type=script&lang=js&"
export * from "./EditLiteralComponent.vue?vue&type=script&lang=js&"
import style0 from "./EditLiteralComponent.vue?vue&type=style&index=0&id=c4d82334&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d82334",
  null
  
)

export default component.exports